import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { CommonUtilsModule } from "../common-utils/common-utils.module";
import { RowSelectionControlDeleteComponent } from "./ctas/delete.component";
import { RowSelectionManagerDirective } from "./manager.directive";
import { RowSelectionComponent } from "./row-selection.component";
import { SelectAllDirective } from "./select-all.directive";
import { SelectSelfDirective } from "./select-self.directive";
import { SelectableComponent } from "./selectable.component";
import { listControlsStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CommonUtilsModule,
    ],
    exports: [
        ...[
            RowSelectionComponent,
            RowSelectionControlDeleteComponent,
            SelectableComponent,
            SelectSelfDirective,
            SelectAllDirective,
            RowSelectionManagerDirective,
        ],
        CommonUtilsModule,
    ],
    declarations: [
        RowSelectionComponent,
        RowSelectionControlDeleteComponent,
        SelectableComponent,
        SelectSelfDirective,
        SelectAllDirective,
        RowSelectionManagerDirective,
    ],
    providers: [
        SelectableComponent,
        RowSelectionManagerDirective,
        listControlsStatePropProvider,
    ],
})
export class RowSelectionModule {
}
